"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizes = exports.fonts = void 0;
var fonts = {
  body: 'Roboto, \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  heading: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  lcScript: '\'LC Script\', \'Brush Script MT\', \'Times Italic\', \'Times New Roman\', cursive',
  mrEaves: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  roboto: 'Roboto, \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  monospace: 'Menlo, monospace'
};
exports.fonts = fonts;
var fontSizes = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88];
exports.fontSizes = fontSizes;